import { Injectable, Injector } from '@angular/core';
import { ErrorGA4, KioskPropertiesGa4 } from '@app/models';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Observable, Subject } from 'rxjs';
import { CussService } from './cuss.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalsService } from './micro/globals.service';
import { UrlService } from './url.service';
import { KioskPropertiesGA4Int, ReciptPaymentGA4Int, SessionGa4Int } from '@app/interfaces/ga4.interface';
import { SessionStartGa4 } from "@app/models/ga4/sessionStartGa4.model";
import { LookUpPnrService } from '@app/services/micro/lookup-pnr.service';
import moment from 'moment';
import { ReciptPaymentGa4 } from '@app/models/ga4/reciptPaymentGa4.model';
import { Reservation } from '@app/models/micro';
@Injectable({
  providedIn: 'root'
})
export class Ga4Service {

  listen$: Subject<any> = new Subject<any>();
  sessionGa4: SessionGa4Int;
  sessionDateStart:Date;
  nameSession:string;
  constructor(
    private _googleTagManager: GoogleTagManagerService,
    private _cussService: CussService,
    private _translateService: TranslateService,
    private _globalService: GlobalsService,
    //private _globalsServiceOld: GlobalsServiceOld,
    private injector: Injector,
    private _urlService: UrlService
  ) { }

  initGa4() {
    this._googleTagManager.addGtmToDom().then(response => {
      this.listen$.next({ code: 'initGa4', data: response });
    });
  }

  getDatalayer() {
    return this._googleTagManager.getDataLayer();
  }

  listen(): Observable<any> {
    return this.listen$.asObservable();
  }

  sendEvent(event) {
    this._googleTagManager.pushTag(event).then(response => {
      this.listen$.next({ code: 'sendEvent', data: response });
    });
  }

  sendErrorEvent(data) {
    const errorEvent = new ErrorGA4(data);
    this.sendEvent(errorEvent);
  }

  sendKioskPropertiesEvent(data: KioskPropertiesGA4Int) {
    const userPropData = this.getDataUserProperties();
    const kioskEvent = new KioskPropertiesGa4({ ...data, ...userPropData });
    this.sendEvent(kioskEvent);
  }

  sendReiptPayment(data: ReciptPaymentGA4Int){
     const kioskEvent = new ReciptPaymentGa4({ ...data });
    this.sendEvent(kioskEvent);
  }

  getDataUserProperties() {
    const kioskId = this._cussService.KioskID;
    const storef = this._translateService.currentLang.toLowerCase();
    const language = this._globalService.languageSelected;
    const beforeUrl = this._urlService.beforeUrl;
    const reservation = this._globalService.getReservation();

    const userPropertiesData: KioskPropertiesGA4Int = {
      kiosk_id: kioskId,
      language: language.text,
      storefront: storef,
      page_referrer: beforeUrl,
      isSeamless: this.computeIsSeamless(reservation)
    };

    return userPropertiesData;
  }

   sendSessionStarEvent(event:string ,subFunnelName: string) {
    this.sessionDateStart = new Date();
     this.sessionGa4 = {
       date_start_session: new Date(),
       session_id_kos: this.getSessionIdKos(event),
       sub_funnel_name: subFunnelName,
       ss_duration_kos:0,
       event:event
     }
     const sessionModel = new SessionStartGa4(this.sessionGa4);
      this.sendEvent(sessionModel);
   }

  getSessionIdKos(subFunnelName: string) {
    this.nameSession = 'KOS-'+ Math.floor(Math.random() * (9999999999 - 1000000000 + 1))
    return this.nameSession
  }

  sendSessionEndEvent (event:string ,subFunnelName: string) {
    const duration = moment().diff(this.sessionDateStart)
      this.sessionGa4 = {
        date_start_session: new Date(),
        session_id_kos: this.nameSession,
        sub_funnel_name: subFunnelName,
        ss_duration_kos: Math.ceil(duration/1000),
        event:event
      }
      const sessionModel  = new SessionStartGa4 (this.sessionGa4);
      this.sendEvent(sessionModel);
    }

  private get lookUpPnrService(): LookUpPnrService {
    return this.injector.get(LookUpPnrService);
  }

  private computeIsSeamless(reservation: Reservation): boolean {
    if (!reservation) return false;
    return this.lookUpPnrService.isSeamless(reservation);
  }

}
